const referrals = {
  headerLink: "Referral program",
} as const;

export { referrals };
